<!-- ------------------------Компонент для редагування телефону ----------------------------------- -->
<template>
  <smallModal @escape="$emit('close')">
    <div>
      <div v-if="startModal">
        <h5 class="enter-phone-title">{{ lang['editPhone'] }} {{ personPhone }}?</h5>
        <p class="enter-phone-text">{{ lang['enterNewPhone'] }}</p>
        <!-- <hr> -->
        <div>
          <div v-if="personPassword">
            <label for="phone_input_edit">{{ lang['Phone'] }}</label>
            <b-form-input type="text" v-model="form.phone" name="login" id="phone_input_edit" :state="phoneState" />
          </div>
          <div v-else class="center-text">
            <span class="grey-span">{{ lang['FirstCreateAnAccountPassword'] }}</span>
          </div>
        </div>
        <!-- <hr> -->
        <div class="buttons">
          <button class="btn btn-secondary" @click="$emit('close')">{{ lang['Сancel'] }}</button>
          <button v-if="personPassword" class="btn btn-success" @click="validPhoneFormat">{{ lang['Proceed'] }}</button>
          <button v-else class="btn btn-success" @click="goAddPass">{{ lang['Proceed'] }}</button>
        </div>
      </div>
      <div v-if="countryModal">
        <div class="confirm-country">
          <span>{{ this.country + " - " + lang['areYourCountry'] }}</span>
        </div>
        <hr>
        <div class="buttons">
          <button class="btn btn-secondary" @click="no">{{ lang['no'] }}</button>
          <button class="btn btn-success" @click="sendPhone">{{ lang['Yes'] }}</button>
        </div>
      </div>
    </div>
  </smallModal>
</template>

<script>
import { keyevent } from '@/main.js'; // Імпорт глобального об'єкта keyevent для обміну подіями між компонентами
import smallModal from '../modals/smallModal'; // Компонент маленького модального вікна
import { regAPi } from '@/API.js';
//import { store } from '@/store.js'; // Глобальне сховище даних
const apiList = new regAPi();
export default {
  props: ['personPhone', 'personPassword'],
  components: {
    smallModal,
  },
  data() {
    return {
      form: {
        phone: ''
      },
      startModal: true,
      countryModal: false,
      country: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      try {
        let input = document.getElementById('phone_input_edit');
        input.focus();
      } catch (err) {
        // console.log(err)
      }
    })
    keyevent.$off('enter');
    keyevent.$on('enter', () => {
      if (this.startModal && !this.countryModal) {
        this.personPassword ? this.validPhoneFormat() : this.goAddPass()
      } else if (!this.startModal && this.countryModal) {
        this.sendPhone()
      }
    })
  },
  methods: {
    no() {
      this.countryModal = false;
      this.startModal = true;
      this.form.phone = '';
      window.say.messageError(this.lang['enterCorrectNumber']);
    },
    // По не известному мнне стечению обстоятельств, мы для изменения номера телефона используем ту же ссылку, что и при добавлении телефона)
    validPhoneFormat() {
      try {
        //Костыльчик для Украины что бы не вводить +38
        if (this.form.phone["0"] == "0") {
          this.form.phone = "38" + this.form.phone
        }
      } catch (err) {
        console.error(err)
      }
      if (this.phoneState) {
        apiList.checkPhone({ phone: this.form.phone }).then(resp => {
          if (resp.data.status == "done") {
            if (resp.data.data.viewModal) {
              this.country = resp.data.data.country.englishname;
              this.startModal = false;
              this.countryModal = true;
            } else if (!resp.data.data.viewModal && resp.data.data.login == 'not found') {
              this.$emit('close');
              this.$emit('gopassword', { new_phone: this.form.phone })
            } else {
              window.say.messageError(this.lang['PhoneAlreadyRegistered']);
            }
          } else if (resp.data.status == "error") {
            this.$emit('close');
            if (Array.isArray(resp.data.error)) {
              for (let key in resp.data.error) {
                window.say.messageError(resp.data.error[key]);
              }
            } else if (typeof resp.data.error == 'string') {
              window.say.messageError(resp.data.error);
            }
          } else {
            this.$emit('close');
            window.say.messageError("unknown error:0177");
          }
        })
      } else {
        window.say.messageError(this.lang['WrongFormat'])
      }
    },
    sendPhone() {
      this.$emit('close');
      this.$emit('gopassword', { new_phone: this.form.phone })
    },
    // если юзер захотел поменять телефон, но он не додумался ранее создать пароль себе
    goAddPass() {
      this.$emit('close');
      this.$emit('goaddpass')
    }
  },
  computed: {
    phoneState() {
      if (this.form.phone && this.form.phone.length >= 4 && !isNaN(this.form.phone)) {
        return true;
      } else {
        return false;
      }
    },
    // Мова додатку
    lang() {
      return window.lang;
    },
  }
}
</script>

<style scoped>
.enter-phone-title {
  /* font-size: 17px; */
  font-size: 16px;
  font-weight: 600;
}

.enter-phone-text {
  /* font-size: 17px; */
  font-size: 16px;
  color: #8A8E91;
}

.form-control.is-valid,
.form-control.is-valid:focus {
  border-color: #00c279;
}

.form-control.is-valid {
  border-color: #00c279;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2300C279' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
}

.form-control.is-invalid,
.form-control.is-invalid:focus {
  border-color: #ff3548;
}

.form-control.is-invalid {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ff3548' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
}

.btn-secondary,
.btn-success {
  width: 49%;
}

.buttons {
  display: flex;
  justify-content: space-between;
}

.btn-success {
  background-color: #00c279;
  border: none;
  text-transform: uppercase;
  font-size: 10pt;
}

.btn-success:not(:disabled):not(.disabled):active {
  background-color: #00B26F;
}

.btn-success:hover {
  background-color: #00B26F;
}

.btn-secondary {
  color: gray;
  background-color: white;
  border: none;
  text-transform: uppercase;
  font-size: 10pt;
}

.btn-secondary:not(:disabled):not(.disabled):active {
  background-color: white;
  color: gray;
}

.btn-secondary:hover {
  text-decoration: underline;
  color: gray;
  background-color: white;
}

.center-text {
  text-align: center;
}

.grey-span {
  color: grey;
}

/*не знаю почему но если этого нету то кнопка обновления капчи меняет разположение на левую сторону (смена телефона)*/
.buttons-flex-end {
  display: flex;
  justify-content: flex-end;
}
</style>